// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-footer {
  width: 100%;
  color: var(--footer-text-color);
  background-color: var(--footer-bg-color);
  background-image: var(--footer-bg-image-mobile);
  background-size: cover;
  background-repeat: no-repeat;
  font-size: var(--footer-font-size-mobile);
  text-align: left;
}
@media (min-width: 1200px) {
  .block-footer {
    background-image: var(--footer-bg-image-desktop);
    font-size: var(--footer-font-size-desktop);
  }
}
.block-footer__powered {
  font-size: 0.95rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.block-footer__powered img {
  height: var(--footer-logo-height-mobile);
}
@media (min-width: 1200px) {
  .block-footer__powered img {
    height: var(--footer-logo-height-desktop);
  }
}
@media (min-width: 768px) {
  .block-footer__container {
    padding-left: 70px;
    padding-right: 70px;
  }
}
.block-footer__powered-label {
  display: block;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 8px;
}
.block-footer__copyright {
  margin-bottom: 0.5rem;
}
.block-footer.centered {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Footer/Footer.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,+BAAA;EACA,wCAAA;EACA,+CAAA;EACA,sBAAA;EACA,4BAAA;EACA,yCAAA;EACA,gBAAA;AADJ;AAGI;EAVJ;IAWQ,gDAAA;IACA,0CAAA;EAAN;AACF;AAEI;EACI,kBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAAR;AAEQ;EACI,wCAAA;AAAZ;AAEY;EAHJ;IAIQ,yCAAA;EACd;AACF;AAIQ;EADJ;IAEQ,kBAAA;IACA,mBAAA;EADV;AACF;AAII;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAFR;AAKI;EACI,qBAAA;AAHR;AAMI;EACI,kBAAA;AAJR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
